import React from 'react';
import { Field } from 'react-final-form';
import { Error } from "./error";

export function DataClassifications(props) {
    const { classes } = props;
    let hsi = -1
    for (let si = 0; si < classes.length; si ++) {
        if (classes[si].label === "HSD") {
            hsi = si
        }
    }
    if (hsi !== -1) {
        classes.splice(hsi, 1)
    }
    return (
    <div>
        <h3>Regulatory Classification(s)*</h3>
        <Error name="compliance" />
        <table>
            <tbody>
            {
                classes.map((compliance) =>
                <tr key={compliance.label}>
                    <td>
                    <label>
                        <Field
                            name="compliance"
                            component="input"
                            type="checkbox"
                            value={compliance.label}
                            validate={props.validation}
                        />{' '}
                        {compliance.label}
                    </label>
                    </td>
                </tr>
            )}
            <tr>
                <td>
                <label>
                    <Field
                        name="compliance"
                        component="input"
                        type="checkbox"
                        value="Other"
                        validate={props.validation}
                    />{' '}
                    {"Other Sensitive Data:"}<br></br>
                    <Field name="sensitivity">
                        {({ input }) => (
                            <input {...input} type="text" />
                        )}
                    </Field>
                </label>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    );
}
